module.exports = __webpack_public_path__ + "static/media/ourbrands-logo1.03bd5a5c.webp";